import { render, staticRenderFns } from "./AccountBenefits.vue?vue&type=template&id=bda56ddc&"
import script from "./AccountBenefits.vue?vue&type=script&lang=js&"
export * from "./AccountBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports